// Inspired by https://github.com/sveltejs/svelte/discussions/12992#discussioncomment-10439371
export function debounce <T> (getter: () => T, delay: number) {
  // Initialization is not debounced
  let value = $state(getter())
  let timer
  $effect(() => {
    clearTimeout(timer)
    timer = setTimeout(() => value = getter(), delay)
    return () => clearTimeout(timer)
  })
  return () => value
}
